import '@ui5/webcomponents-react';
import validator from 'validator';

import ValueState from '@ui5/webcomponents-base/dist/types/ValueState.js';

export const validateDeadline = (
  setValueState: (valueState: ValueState) => void,
  value: string,
  valid: boolean
): boolean => {
  if (value && valid) {
    setValueState(ValueState.Positive);
    return true;
  }

  setValueState(ValueState.Negative);
  return false;
};

export const validateString = (
  value: string,
  setValueState: (valueState: ValueState) => void,
  invalidState: ValueState = ValueState.Negative,
  validState: ValueState = ValueState.Positive
): boolean => {
  if (value && value.trim() !== '') {
    setValueState(validState);
    return true;
  } else {
    setValueState(invalidState);
    return false;
  }
};

export const validateTwoDifferentStrings = (
  value: string,
  value2: string,
  setValueState: (valueState: ValueState) => void
): boolean => {
  if (value !== value2) {
    setValueState(ValueState.Positive);
    return true;
  } else {
    setValueState(ValueState.Negative);
    return false;
  }
};

export const validateProject = (
  value: string,
  setValueState: (valueState: ValueState) => void
): boolean => {
  if (value === '-1') {
    setValueState(ValueState.Negative);
    return false;
  }
  setValueState(ValueState.Positive);
  return true;
};

export const validateAssigneeEmail = (
  queryAssignee: string,
  value: string,
  setValueState: (valueState: ValueState) => void
): boolean => {
  if (validator.isEmail(value) || (queryAssignee === '' && value === '')) {
    setValueState(ValueState.Positive);
    return true;
  } else {
    setValueState(ValueState.Negative);
    return false;
  }
};

export const validateEmail = (
  value: string,
  setValueState?: (valueState: ValueState) => void
): boolean => {
  const isValid = value !== '' && validator.isEmail(value);
  if (setValueState) {
    setValueState(isValid ? ValueState.Positive : ValueState.Negative);
  }
  return isValid;
};

export const validateFieldLength = (
  value: string,
  length: number,
  setValueState: (valueState: ValueState) => void
): boolean => {
  if (value.length === 0 || value.length >= length) {
    setValueState(ValueState.None);
    return true;
  }
  setValueState(ValueState.Negative);
  return false;
};

export const validateSAPUserId = (
  userId: string,
  setValueState: (valueState: ValueState) => void
): boolean => {
  const pattern = /^(C[0-9]{7}|[DI][0-9]{6})$/i;
  const result = pattern.test(userId);
  setValueState(result ? ValueState.Positive : ValueState.Negative);
  return result;
};
